import * as React from "react";
import Badge, {BadgeProps} from '@mui/material/Badge';

import {styled} from '@mui/material/styles';

export const CBadge = styled(Badge)<BadgeProps>(
  (/* { theme } */) => ({
  }),
);
